import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { Observable, Subject } from 'rxjs';
import { ProcessWithForm } from '../../interfaces/process-with-form.interface';
import { FormViewerComponent, FormViewerComponentData } from '../../components/form-viewer/form-viewer.component';
import { mergeMap, retryWhen, switchMap, tap } from 'rxjs/operators';
import { FormField } from '../../../../../../../sellions_forms/projects/forms/src/lib/interfaces/form-field.interface';
import { FormVariables } from '../../../../../../../sellions_forms/projects/forms/src/lib/interfaces/form-variables.interface';
import { ObservableWorkaround } from '../../utils/observable-workaround.class';

@Injectable()
export class DisplayFormService {
  constructor(private dialog: MatDialog) {}

  public displayForm(
    baseUrl: string,
    formJson: FormField[],
    proc: ProcessWithForm,
    sendData: (formVariables: FormVariables) => Observable<any>,
    formError: Subject<string>,
  ): Observable<any> {
    const data: FormViewerComponentData = {
      form: formJson,
      formName: proc.formName,
      sendButtonText: proc.sendButtonText,
      formError,
      dataViewBaseAPI: baseUrl,
      answers: proc.data,
    };

    const formViewerRef = this.dialog.open(FormViewerComponent, {
      panelClass: 'process-start-dialog',
      disableClose: true,
      data,
    });

    return formViewerRef.componentInstance.processVariables.pipe(
      mergeMap((processVariables) => sendData(processVariables)),
      tap(() => formViewerRef.close()),
      retryWhen((errors) =>
        errors.pipe(
          switchMap((errorWithProcessFormAndVariables) => this.handleFormViewerError(errorWithProcessFormAndVariables, formViewerRef, formError)),
        ),
      ),
    );
  }

  private handleFormViewerError(
    errorWithProcessFormAndVariables: { error: any; process: ProcessWithForm; variables: FormVariables },
    formViewerRef: MatDialogRef<FormViewerComponent>,
    formError: Subject<string>,
  ): Observable<any> {
    if (errorWithProcessFormAndVariables.error.status === 0) {
      return this.closeFormViewerAndForwardError(errorWithProcessFormAndVariables, formViewerRef);
    }

    return this.tryShowErrorMessageAndBeReadyForRetry(errorWithProcessFormAndVariables, formViewerRef, formError);
  }

  private closeFormViewerAndForwardError(
    errorWithProcessFormAndVariables: { error: any; process: ProcessWithForm; variables: FormVariables },
    formViewerRef: MatDialogRef<FormViewerComponent>,
  ): Observable<any> {
    formViewerRef.close();
    return ObservableWorkaround.throw(errorWithProcessFormAndVariables);
  }

  private tryShowErrorMessageAndBeReadyForRetry(
    errorWithProcessFormAndVariables: { error: any; process: ProcessWithForm; variables: FormVariables },
    formViewerRef: MatDialogRef<FormViewerComponent>,
    formError: Subject<string>,
  ): Observable<any> {
    if (errorWithProcessFormAndVariables.error.error) {
      formError.next(errorWithProcessFormAndVariables.error.error);
    }

    formViewerRef.componentInstance.isSendButtonDisabled = false;

    return ObservableWorkaround.of(errorWithProcessFormAndVariables);
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/services/form/display-form.service.ts